import { useMe } from "@podtrac/common/accounts";
import { ModalHeader } from "@podtrac/common/components/ModalHeader";
import axios from "axios";
import { Field, Form, Formik, useField } from "formik";
import React, { useCallback } from "react";
import Modal from "react-modal";
import * as Yup from "yup";
import { useUpdateProfile } from "./user-queries";

const loadingValues = {
    name: "",
    email: "",
    password: ""
};

const modalStyles = {
    content: {
        // https://www.joshwcomeau.com/css/center-a-div/
        position: "fixed",
        inset: 0,
        width: "fit-content",
        height: "fit-content",
        margin: "auto",
    },
};

export function EditProfileModal({ isOpen, close }) {

    const query = useMe();
    const me = query.data?.me;

    const updateProfile = useUpdateProfile();

    const emailAvailable = useCallback(
        (email) => axios.get("/api/me/email-available", { params: { email } })
            .then(res => res.data === true),
        []);

    const validationSchema = Yup.object().shape({
        name: Yup.string().label("Name").max(100).required(),
        email: Yup.string().label("Email").email().max(256).required()
            .test(
                "checkEmailAvaliable",
                "Email address is already in use",
                emailAvailable
            ),
        password: Yup.string().label("Password").min(8).nullable(),
    });

    if (!me) return;

    return <Modal
        isOpen={isOpen}
        onRequestClose={close}
        style={modalStyles}
        contentLabel="Edit Your Profile"
    >
        <ModalHeader close={close}>Edit Your Profile</ModalHeader>
        <Formik
            onSubmit={values => updateProfile.mutateAsync(values).then(close)}
            initialValues={me ?? loadingValues}
            validationSchema={validationSchema}
            enableReinitialize
        >
            <Form disabled={!me} className="form" style={{ marginTop: "1em" }}>

                <label className="label">Name</label>
                <div className="field">
                    <Field name="name" type="text" />
                    <InfoOrErrorMessage name="name" />
                </div>

                <label className="label">Email</label>
                <div className="field">
                    <Field name="email" type="text" />
                    <InfoOrErrorMessage name="email" />
                </div>

                <label className="label">Password</label>
                <div className="field">
                    <Field name="password" type="password" />
                    <InfoOrErrorMessage name="password" info="Leave blank, or enter a new password to change" />
                </div>

                <div className="buttons">
                    <button type="submit">Save</button>
                </div>
            </Form>
        </Formik>
    </Modal>;
}

function InfoOrErrorMessage({ name, info }) {
    const [field, meta, helpers] = useField(name);
    return <div className={ meta.error ? "error" : "info"}>{ meta.error ? meta.error : info ?? "\u2003"}</div>;
}